<template>
    <a class="btn btn-outline-danger" @click.prevent="submit">
        Remove
    </a>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import axios from 'axios';

export default {
  props: {
    workOrder: {
      type: String,
      required: true,
    },
    part: {
      type: Number,
      required: true,
    },
  },

  methods: {
    async submit() {
      // eslint-disable-next-line no-restricted-globals
      if (!confirm('Are you sure you want to remove this part? \nPlease Note: The page will refresh automatically once completed.')) {
        return;
      }

      await axios.delete(`/admin/work-orders/${this.workOrder}/parts/${this.part}`, {
        headers: {
          'Content-Type': 'application/json',
          'X-XSRF-Token': document.querySelector('meta[name=csrf-token]').content,
        },
      });

      window.location.reload();
    },
  },
};
</script>
